import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
export const useEventListTotalCount = institutionId => {
  const $ = _c(5);
  const {
    entry
  } = useWebviewTypeEntry();
  let t0;
  if ($[0] !== entry || $[1] !== institutionId) {
    t0 = UnauthQueryOptions["get:/wello/v2/allows/home/institution-event"]({
      query: {
        excludeEndedYN: true,
        institutionId,
        page: 1,
        size: 1,
        entry
      }
    });
    $[0] = entry;
    $[1] = institutionId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = {
      ...t0,
      select: _temp
    };
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return useQuery(t1);
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context?.totalCount;
}